import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BackendService } from '@core/services';
import { Dict, FooterLink } from '@shared/models';

@Component({
  selector: 'b2c-footer-link',
  imports: [RouterLink],
  templateUrl: './footer-link.component.html',
})
export class FooterLinkComponent {
  itemStyles = input<Dict>({});
  item = input.required<FooterLink>();

  public untienotsId: string = inject(BackendService).untienotsId;
}
